<template>
  <v-dialog lazy v-model="cropping" width="auto">
    <v-card width="auto">
      <div>
        <cropper ref="cropper" class="avatar-cropper" :src="image" :stencilProps="{ aspectRatio: 1 }" />
        <input type="file" ref="dropzone" @change="onDropZoneChange" class="pb-15" style="display: none" />
        <div class="button-wrapper">
          <v-btn :color="themes.candidate.light.success" @click="cropImage">
            Save
          </v-btn>
          <v-btn :color="themes.candidate.light.cancel" @click="cancel" flat>
            Cancel
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
  
<script>
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

export default {
  name: "AvatarCropper",
  components: {
    Cropper
  },
  props: {
    image: String
  },
  data() {
    return {
      cropping: true
    };
  },
  methods: {
    cropImage() {
      const result = this.$refs.cropper.getResult();
      this.$emit('done', result.canvas.toDataURL("image/jpeg"));
    },
    cancel() {
      this.$emit('cancel');
    },
    onDropZoneChange(e) {
      const file = e.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.image = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    }
  }
};
</script>
  
<style>
.avatar-cropper {
  border: solid 1px #eee;
  min-height: 300px;
  width: 100%;
  height: 75vh;
}

.button-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 17px;
}
</style>
